










import Vue from "vue";
import Navbar from "./components/Navbar.vue";
import Landing from "./Landing.vue";
export default Vue.extend({
  name: "App",
  components: {
    "nav-bar": Navbar,
    Landing
  }
});
